import { useState } from 'react';
import { useNotifications } from '../context/NotificationContext';
import { testPush } from '../api/chat';

// LINK TẢI APP NATIVE (điền đường link vào đây khi có bản build).
// APK Android: link tải file .apk trực tiếp. TestFlight iOS: link mời TestFlight công khai.
const APK_URL = 'https://funnytask.net/download/funnytask.apk'; // file APK mới nhất (host trên server)
const TESTFLIGHT_URL = '';     // vd: 'https://testflight.apple.com/join/xxxxxxxx' (điền khi có TestFlight)

// Đang chạy dưới dạng APP đã cài (không phải tab Chrome)?
const isStandalone = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
const isAndroid = () => /Android/i.test(navigator.userAgent);
const isIOS = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

function Step({ n, title, children }) {
  return (
    <div className="guide-step">
      <div className="guide-num">{n}</div>
      <div>
        <div className="guide-step-title">{title}</div>
        {children && <div className="small muted" style={{ marginTop: 3 }}>{children}</div>}
      </div>
    </div>
  );
}

export default function GuidePage() {
  const { permission, enableBrowserNotifications } = useNotifications();
  const [testing, setTesting] = useState(false);
  const [result, setResult] = useState(null);

  const installed = isStandalone();
  const android = isAndroid();
  const ios = isIOS();
  const onPhone = android || ios;

  async function doTest() {
    setTesting(true);
    setResult(null);
    try {
      const r = await testPush(); // { subs, sent }
      if (!r.subs) setResult({ ok: false, msg: 'Máy này CHƯA đăng ký nhận thông báo. Làm bước 2 bên dưới (bấm chuông 🔔 → Bật) rồi thử lại.' });
      else if (r.sent) setResult({ ok: true, msg: `Đã gửi thông báo thử tới ${r.sent}/${r.subs} thiết bị. Kiểm tra thanh thông báo trên điện thoại nhé!` });
      else setResult({ ok: false, msg: `Có ${r.subs} đăng ký nhưng gửi không thành công. Thử bấm Bật lại, hoặc gỡ app rồi cài lại.` });
    } catch (e) {
      setResult({ ok: false, msg: e.response?.data?.message || 'Không gửi được — thử lại sau.' });
    } finally {
      setTesting(false);
    }
  }

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h2>Hướng dẫn sử dụng</h2>
          <div className="sub">Cài FunnyTask lên điện thoại và bật thông báo</div>
        </div>
      </div>

      {/* Trạng thái máy đang dùng — để NV biết mình đang thiếu bước nào */}
      <div className="card">
        <h3>Máy bạn đang dùng</h3>
        <div className="guide-status">
          <div className={'guide-chip' + (installed ? ' ok' : '')}>
            {installed ? '✅ Đã cài app' : '⬜ Chưa cài app'}
          </div>
          <div className={'guide-chip' + (permission === 'granted' ? ' ok' : permission === 'denied' ? ' bad' : '')}>
            {permission === 'granted' ? '✅ Đã bật thông báo' : permission === 'denied' ? '⛔ Đang CHẶN thông báo' : '⬜ Chưa bật thông báo'}
          </div>
        </div>
        {!onPhone && (
          <div className="small muted" style={{ marginTop: 8 }}>
            Bạn đang xem trên máy tính. Mở <b>funnytask.net</b> trên điện thoại để làm theo hướng dẫn dưới đây.
          </div>
        )}
        {android && !installed && (
          <div className="small muted" style={{ marginTop: 8 }}>
            Bạn đang dùng <b>Android</b> — làm theo phần <b>📱 Điện thoại Android</b> bên dưới.
          </div>
        )}
        {ios && !installed && (
          <div className="small muted" style={{ marginTop: 8 }}>
            Bạn đang dùng <b>iPhone</b> — làm theo phần <b>🍎 iPhone / iPad</b> bên dưới. Nhớ mở bằng <b>Safari</b>.
          </div>
        )}

        <div className="row" style={{ gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
          {permission !== 'granted' && (
            <button className="btn" onClick={enableBrowserNotifications}>🔔 Bật thông báo ngay</button>
          )}
          <button className="btn ghost" disabled={testing} onClick={doTest}>
            {testing ? 'Đang gửi…' : '✉️ Gửi thử thông báo cho tôi'}
          </button>
        </div>
        {result && (
          <div className="small" style={{ marginTop: 10, color: result.ok ? 'var(--ok)' : 'var(--danger)', fontWeight: 600 }}>
            {result.ok ? '✅ ' : '⚠️ '}{result.msg}
          </div>
        )}
      </div>

      {/* ANDROID */}
      <div className="card">
        <h3>📱 Điện thoại Android — cài app</h3>
        <div className="small muted" style={{ marginBottom: 12 }}>
          Cài xong sẽ có <b>icon FunnyTask ngoài màn hình chính</b> như một ứng dụng thật, mở nhanh hơn và
          <b> nhận được thông báo kể cả khi đã đóng app</b>.
        </div>
        {APK_URL && (
          <div style={{ marginBottom: 12 }}>
            <a className="btn" href={APK_URL} download style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              ⬇️ Tải app Android (APK)
            </a>
            <div className="small muted" style={{ marginTop: 6 }}>
              Cách nhanh nhất: tải file APK rồi bấm mở để cài. Nếu máy hỏi thì bật <b>"Cho phép cài từ nguồn này"</b>.
              Hoặc làm theo các bước cài từ Chrome bên dưới.
            </div>
          </div>
        )}
        <Step n="1" title="Mở Chrome, vào funnytask.net rồi đăng nhập">
          Phải dùng <b>Chrome</b> (không dùng Cốc Cốc / trình duyệt trong Facebook, Zalo).
        </Step>
        <Step n="2" title="Bấm dấu ⋮ (ba chấm) ở góc trên bên phải" />
        <Step n="3" title='Chọn "Cài đặt ứng dụng"'>
          Nếu không thấy dòng đó, chọn <b>"Cài đặt và tạo lối tắt"</b> — cùng tác dụng.
        </Step>
        <Step n="4" title='Bấm "Cài đặt" ở hộp thoại hiện ra'>
          Icon <b>Ft FunnyTask</b> sẽ xuất hiện ngoài màn hình chính.
        </Step>
      </div>

      {/* BẬT THÔNG BÁO */}
      <div className="card">
        <h3>🔔 Bật thông báo (làm SAU khi đã cài app)</h3>
        <div className="guide-warn">
          ⚠️ Quan trọng: phải <b>mở app từ icon ngoài màn hình chính</b>, không phải từ tab Chrome. Bật trong tab
          Chrome thì thông báo sẽ không chạy ổn định.
        </div>
        <Step n="1" title="Mở app FunnyTask từ icon ngoài màn hình chính" />
        <Step n="2" title="Bấm hình chuông 🔔 ở góc trên bên phải" />
        <Step n="3" title='Bấm nút "Bật"' >
          Hoặc bấm thẳng nút <b>"🔔 Bật thông báo ngay"</b> ở đầu trang này.
        </Step>
        <Step n="4" title='Chrome hỏi quyền → chọn "Cho phép"' />
        <Step n="5" title='Bấm "✉️ Gửi thử thông báo cho tôi" ở đầu trang để kiểm tra'>
          Thấy thông báo hiện ra là xong. Từ giờ có tin nhắn hay giao việc mới, điện thoại sẽ báo ngay.
        </Step>
      </div>

      {/* IPHONE */}
      <div className="card">
        <h3>🍎 iPhone / iPad — cài app</h3>
        {TESTFLIGHT_URL && (
          <div style={{ marginBottom: 12 }}>
            <a className="btn" href={TESTFLIGHT_URL} target="_blank" rel="noopener noreferrer" style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              ⬇️ Tải app iOS qua TestFlight
            </a>
            <div className="small muted" style={{ marginTop: 6 }}>
              Cài app <b>TestFlight</b> từ App Store trước, rồi bấm link này để nhận bản FunnyTask.
              Hoặc dùng cách cài từ Safari bên dưới (không cần TestFlight).
            </div>
          </div>
        )}
        <div className="guide-warn">
          ⚠️ iPhone <b>bắt buộc phải cài app</b> mới nhận được thông báo — mở bằng Safari bình thường sẽ
          <b> không bao giờ</b> có thông báo. Máy cần <b>iOS 16.4 trở lên</b>.
        </div>
        <Step n="1" title="Mở funnytask.net bằng Safari">
          Bắt buộc dùng <b>Safari</b>. Chrome/Cốc Cốc trên iPhone <b>không cài được</b> (Apple chỉ cho Safari làm việc này).
        </Step>
        <Step n="2" title="Bấm nút Chia sẻ ở thanh dưới">
          Nút hình <b>ô vuông có mũi tên hướng lên</b> ⬆️.
        </Step>
        <Step n='3' title='Chọn "Thêm vào Màn hình chính"'>
          Không thấy dòng này thì kéo danh sách xuống, hoặc bấm <b>"Xem thêm"</b> / <b>"Tùy chọn ›"</b> để hiện đầy đủ.
        </Step>
        <Step n="4" title='Giữ nguyên công tắc "Mở dưới dạng ứng dụng web" ở trạng thái BẬT (xanh)'>
          Đây là bước <b>quan trọng nhất</b>. Nếu tắt công tắc này, icon chỉ là lối tắt mở Safari —
          <b> sẽ không có thông báo</b>.
        </Step>
        <Step n='5' title='Bấm "Thêm" ở góc trên bên phải'>
          Icon <b>Ft FunnyTask</b> sẽ xuất hiện ngoài màn hình chính.
        </Step>
      </div>

      {/* BẬT THÔNG BÁO TRÊN IPHONE */}
      <div className="card">
        <h3>🍎🔔 iPhone — bật thông báo</h3>
        <Step n="1" title="Mở app FunnyTask từ icon ngoài màn hình chính">
          Không phải mở từ Safari. Mở đúng từ icon thì thanh địa chỉ của Safari sẽ <b>không còn hiện</b> nữa.
        </Step>
        <Step n="2" title="Đăng nhập (lần đầu mở app phải đăng nhập lại)" />
        <Step n="3" title="Bấm hình chuông 🔔 ở góc trên bên phải → bấm nút “Bật”" />
        <Step n='4' title='iPhone hỏi “FunnyTask muốn gửi thông báo cho bạn” → chọn "Cho phép"'>
          Hộp thoại này <b>chỉ hiện 1 lần duy nhất</b>. Lỡ bấm "Từ chối" thì xem phần khắc phục bên dưới.
        </Step>
        <Step n="5" title='Bấm "✉️ Gửi thử thông báo cho tôi" ở đầu trang để kiểm tra' />
      </div>

      {/* KHẮC PHỤC */}
      <div className="card">
        <h3>❓ Không nhận được thông báo?</h3>
        <ul className="guide-list">
          <li><b>Chưa mở app từ icon:</b> đây là lỗi hay gặp nhất. Đóng tab trình duyệt, mở lại bằng icon ngoài màn hình chính.</li>
          <li><b>Android — lỡ bấm "Chặn":</b> vào Cài đặt điện thoại → Ứng dụng → FunnyTask (hoặc Chrome) → Thông báo → bật lại cho <b>funnytask.net</b>.</li>
          <li><b>iPhone — lỡ bấm "Từ chối":</b> vào <b>Cài đặt → Thông báo → FunnyTask</b> → bật "Cho phép thông báo". Nếu không thấy FunnyTask trong danh sách thì <b>xoá icon đi và cài lại</b> theo hướng dẫn trên (nhớ bật "Mở dưới dạng ứng dụng web").</li>
          <li><b>iPhone — icon mở ra vẫn thấy thanh địa chỉ Safari:</b> nghĩa là lúc cài đã <b>tắt</b> công tắc "Mở dưới dạng ứng dụng web" → chỉ là lối tắt, không có thông báo. Xoá icon, cài lại và để công tắc BẬT.</li>
          <li><b>iPhone chạy iOS cũ hơn 16.4:</b> Apple chưa hỗ trợ thông báo cho web app. Cần cập nhật iOS.</li>
          <li><b>Chế độ tiết kiệm pin:</b> một số máy (Xiaomi, Oppo, Vivo, Samsung) tự chặn app chạy nền. Vào Cài đặt → Pin → bỏ giới hạn cho FunnyTask.</li>
          <li><b>Đang mở sẵn màn hình chat đó:</b> lúc bạn đang nhìn cuộc trò chuyện thì hệ thống không báo nữa (tránh làm phiền).</li>
          <li><b>Đã tắt âm hội thoại:</b> mở cuộc trò chuyện → kiểm tra xem có đang tắt âm không.</li>
          <li>Vẫn không được thì bấm <b>"✉️ Gửi thử thông báo cho tôi"</b> ở đầu trang rồi báo kết quả cho kỹ thuật.</li>
        </ul>
      </div>
    </div>
  );
}
